module.exports = __webpack_public_path__ + "img/16_38.f9a0cfcf.png";